export default function RunHistory({}: any) {
  return null;
}
